import { useMemo } from 'react';
import ServiceRequestContext, { ServiceRequestContextData } from './context';

export interface ServiceRequestContextProviderProps extends ServiceRequestContextData {
  children: React.ReactNode;
}

const ServiceRequestContextProvider = ({ children, ...serviceRequestContextData }: ServiceRequestContextProviderProps) => {
  const memoizedServiceRequestContextData = useMemo(() => serviceRequestContextData, [serviceRequestContextData]);
  return <ServiceRequestContext.Provider value={memoizedServiceRequestContextData}>{children}</ServiceRequestContext.Provider>
};

export default ServiceRequestContextProvider;